import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/gif/preloader.gif")